import type {Progress} from './progressSchema';

export interface ProgressTotals {
  totalAnswered: number;
  totalCorrect: number;
}

export function calculateProgressTotals(progress: Progress): ProgressTotals {
  return progress.scores.reduce<ProgressTotals>(
    (acc, s) => ({
      totalAnswered: acc.totalAnswered + (s.total ?? 0),
      totalCorrect: acc.totalCorrect + (s.correct ?? 0),
    }),
    {totalAnswered: 0, totalCorrect: 0},
  );
}
